import { render, staticRenderFns } from "./formScreen1.vue?vue&type=template&id=0ff06df7&scoped=true"
import script from "./formScreen1.vue?vue&type=script&lang=js"
export * from "./formScreen1.vue?vue&type=script&lang=js"
import style0 from "./formScreen1.vue?vue&type=style&index=0&id=0ff06df7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff06df7",
  null
  
)

export default component.exports